import type { Actor } from '@/types';

export const actors: Actor[] = [
  {
    id: 'lee-jieun',
    name: '李知恩',
    nameEn: 'Lee Ji-eun',
    photo: 'https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20young%20Korean%20actress%20with%20soft%20dark%20hair%2C%20calm%20confident%20expression%2C%20warm%20neutral%20beige%20studio%20background%2C%20soft%20natural%20lighting%2C%20refined%20cinematic%20photography%2C%20high%20detail%2C%20no%20text&width=600&height=800&seq=kd-actor-01&orientation=portrait',
    bio: '以歌手身份出道，凭细腻真挚的表演成为韩国最具代表性的全能艺人之一。擅长诠释安静却有力量的角色，从都市爱情到现实题材皆游刃有余。',
    birthday: '1993年5月16日',
    height: '162 cm',
    agency: 'EDAM Entertainment',
    representative: ['首尔夜曲', '我们的夏天'],
  },
  {
    id: 'park-seojun',
    name: '朴叙俊',
    nameEn: 'Park Seo-joon',
    photo: 'https://readdy.ai/api/search-image?query=Confident%20editorial%20portrait%20of%20a%20handsome%20young%20Korean%20actor%20in%20a%20smart%20casual%20outfit%2C%20warm%20friendly%20smile%2C%20soft%20amber%20studio%20background%2C%20cinematic%20lighting%2C%20refined%20high%20detail%20photography%2C%20no%20text&width=600&height=800&seq=kd-actor-02&orientation=portrait',
    bio: '从青春偶像剧一路走向大银幕的实力派演员。以自然的喜剧节奏与温暖的角色气场著称，是收视与口碑的双重保证。',
    birthday: '1988年12月16日',
    height: '185 cm',
    agency: 'Awesome ENT',
    representative: ['首尔夜曲', '江南咖啡屋', '财阀家教'],
  },
  {
    id: 'kim-taeri',
    name: '金泰梨',
    nameEn: 'Kim Tae-ri',
    photo: 'https://readdy.ai/api/search-image?query=Striking%20editorial%20portrait%20of%20an%20expressive%20Korean%20actress%20with%20intense%20eyes%2C%20minimal%20dark%20clothing%2C%20muted%20warm%20charcoal%20studio%20background%2C%20dramatic%20soft%20lighting%2C%20high%20detail%20cinematic%20photography%2C%20no%20text&width=600&height=800&seq=kd-actor-03&orientation=portrait',
    bio: '被称作“变色龙”的演技派女演员，能从历史剧一路演到惊悚与家庭伦理。善于在极小的表情里藏住巨大的情绪张力。',
    birthday: '1990年4月24日',
    height: '166 cm',
    agency: 'Management mmm',
    representative: ['王座之影', '深渊回响', '山茶花开'],
  },
  {
    id: 'song-kangho',
    name: '宋康昊',
    nameEn: 'Song Kang-ho',
    photo: 'https://readdy.ai/api/search-image?query=Character%20editorial%20portrait%20of%20a%20seasoned%20Korean%20actor%20with%20a%20thoughtful%20gaze%2C%20simple%20neutral%20clothing%2C%20warm%20muted%20grey%20studio%20background%2C%20soft%20directional%20lighting%2C%20high%20detail%20cinematic%20photography%2C%20no%20text&width=600&height=800&seq=kd-actor-04&orientation=portrait',
    bio: '韩国影坛的国民级演员，以极强的角色塑造能力横跨犯罪、科幻与悬疑题材。台词与沉默同样有分量，是公认的“演员的演员”。',
    birthday: '1967年1月17日',
    height: '180 cm',
    agency: 'Sublime Artist Agency',
    representative: ['无声证词', '深渊回响', '记忆迷宫'],
  },
  {
    id: 'han-sohee',
    name: '韩素希',
    nameEn: 'Han So-hee',
    photo: 'https://readdy.ai/api/search-image?query=Striking%20editorial%20portrait%20of%20a%20beautiful%20young%20Korean%20actress%20with%20long%20dark%20wavy%20hair%2C%20cool%20composed%20expression%2C%20soft%20warm%20taupe%20studio%20background%2C%20elegant%20cinematic%20lighting%2C%20high%20detail%20photography%2C%20no%20text&width=600&height=800&seq=kd-actor-05&orientation=portrait',
    bio: '凭冷冽气质迅速走红的新生代女演员，擅长在犯罪与医疗题材中展现坚韧又脆弱的一面。近年不断挑战反差强烈的角色。',
    birthday: '1994年11月18日',
    height: '165 cm',
    agency: '9ato Entertainment',
    representative: ['无声证词', '江南咖啡屋', '月光医院'],
  },
  {
    id: 'cha-eunwoo',
    name: '车银优',
    nameEn: 'Cha Eun-woo',
    photo: 'https://readdy.ai/api/search-image?query=Bright%20editorial%20portrait%20of%20a%20youthful%20handsome%20Korean%20actor%20with%20a%20gentle%20smile%2C%20light%20casual%20knitwear%2C%20soft%20warm%20cream%20studio%20background%2C%20clean%20natural%20lighting%2C%20high%20detail%20photography%2C%20no%20text&width=600&height=800&seq=kd-actor-06&orientation=portrait',
    bio: '身兼歌手与演员的“脸蛋天才”，近年致力于摆脱偶像标签，在青春与奇幻爱情题材中不断磨练演技。',
    birthday: '1997年3月30日',
    height: '183 cm',
    agency: 'Fantagio',
    representative: ['星屑恋人', '我们的夏天'],
  },
  {
    id: 'jun-jihyun',
    name: '全智贤',
    nameEn: 'Jun Ji-hyun',
    photo: 'https://readdy.ai/api/search-image?query=Glamorous%20editorial%20portrait%20of%20a%20poised%20mature%20Korean%20actress%20with%20elegant%20styled%20hair%2C%20sophisticated%20dark%20blazer%2C%20soft%20warm%20champagne%20studio%20background%2C%20luxurious%20cinematic%20lighting%2C%20high%20detail%20photography%2C%20no%20text&width=600&height=800&seq=kd-actor-07&orientation=portrait',
    bio: '韩国顶级女演员之一，气场与票房号召力兼具。无论喜剧、奇幻还是科幻，都能以极强的存在感牢牢掌控全场。',
    birthday: '1981年10月30日',
    height: '173 cm',
    agency: 'Culture Depot',
    representative: ['星屑恋人', '财阀家教', '记忆迷宫'],
  },
  {
    id: 'lee-dohyun',
    name: '李到晛',
    nameEn: 'Lee Do-hyun',
    photo: 'https://readdy.ai/api/search-image?query=Sensitive%20editorial%20portrait%20of%20a%20young%20Korean%20actor%20with%20soft%20brown%20hair%20and%20a%20gentle%20gaze%2C%20minimal%20beige%20shirt%2C%20warm%20neutral%20studio%20background%2C%20soft%20cinematic%20lighting%2C%20high%20detail%20photography%2C%20no%20text&width=600&height=800&seq=kd-actor-08&orientation=portrait',
    bio: '以细腻情感戏见长的新生代演员，在历史与医疗题材中展现出超越年龄的沉稳，被观众称为“眼泪开关”。',
    birthday: '1995年4月11日',
    height: '182 cm',
    agency: 'Yuehua Entertainment',
    representative: ['王座之影', '高丽星辰', '月光医院'],
  },
];